import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-searchMap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_map = _resolveComponent("m-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.userLocationIsChecked)
      ? (_openBlock(), _createBlock(_component_m_map, {
          key: 0,
          class: "o-searchMap__map",
          brokers: $data.brokers,
          center: [_ctx.longitude, _ctx.latitude],
          "fit-properties": _ctx.fitProperties,
          hovered: _ctx.activeProperty,
          "is-loading": _ctx.mapIsLoading,
          "max-bounds": $data.maxBounds,
          message: 
                !$data.isDesktop && !_ctx.mapIsLoading && !_ctx.properties.length
                    ? $props.texts.noResults
                    : ''
            ,
          polygon: $options.polygon,
          properties: _ctx.properties,
          "scroll-zoom": true,
          "show-polygon": _ctx.area && _ctx.area.length > 0,
          "show-draw": true,
          zoom: _ctx.zoom,
          texts: $props.texts,
          onDraw: $options.onDraw,
          onHover: _ctx.setActiveProperty,
          onLoad: $options.onLoad,
          onMove: $options.onMove
        }, null, 8 /* PROPS */, ["brokers", "center", "fit-properties", "hovered", "is-loading", "max-bounds", "message", "polygon", "properties", "show-polygon", "zoom", "texts", "onDraw", "onHover", "onLoad", "onMove"]))
      : _createCommentVNode("v-if", true)
  ]))
}